import Guid from "@/app/types/common/guid";
import { MenuItem } from "@/app/ui/navigation/types";
import { dutySchemeType } from "@/components/pages/duty/composables/dutyConfiguration";
import { EnumUserPermission } from "@/app/services/generated/enums/enumUserPermission.generated";
import { hasPermissionsUsingUserStore } from "@/components/pages/administration/user_roles/UserAccessHandler";
import { keys } from "@/plugins/i18n";
import { RouteBuilder } from "@/app/ui/navigation/routeBuilder";

const builder = new RouteBuilder("Ullages_");

export const ullageRoutes = {
  list: builder.route({
    url: "/ullages/list-ullages",
    view: (): Promise<any> =>
      import(
        /* webpackChunkName: "ullages" */ "@/pages/ullages/ListUllagesPage.vue"
      ),
  }),
  report: builder.route({
    url: "/ullages/ullage-report",
    view: (): Promise<any> =>
      import(
        /* webpackChunkName: "ullages" */ "@/components/pages/ullages/UllageReport.vue"
      ),
  }),
  create: builder.routeWithParam(
    {
      url: "/ullages/create-ullage",
      view: (): Promise<any> =>
        import(
          /* webpackChunkName: "ullages" */ "@/pages/ullages/UllagePage.vue"
        ),
      componentProps: (route) => ({
        id: Guid.create(),
        createOutletId: Guid.tryParse(route.params.outletId),
        createForContainerId: Guid.tryParse(route.params.createForContainerId),
        mode: "create",
      }),
    },
    (opts?: {
      outletId?: Guid | null;
      createForContainerId?: Guid | null;
    }) => ({
      outletId: opts?.outletId?.toString(),
      createForContainerId: opts?.createForContainerId?.toString(),
    })
  ),
  edit: builder.routeWithParam(
    {
      url: "/ullages/edit-ullage/:id",
      view: (): Promise<any> =>
        import(
          /* webpackChunkName: "ullages" */ "@/pages/ullages/UllagePage.vue"
        ),
      componentProps: (route) => ({
        id: Guid.tryParse(route.params.id),
        mode: "edit",
      }),
    },
    (ullageId: Guid) => ({
      id: ullageId.toString(),
    })
  ),
  view: builder.routeWithParam(
    {
      url: "/ullages/view-ullage/:id",
      view: (): Promise<any> =>
        import(
          /* webpackChunkName: "ullages" */ "@/pages/ullages/UllagePage.vue"
        ),
      componentProps: (route) => ({
        id: Guid.tryParse(route.params.id),
        mode: "view",
      }),
    },
    (ullageId: Guid) => ({
      id: ullageId.toString(),
    })
  ),
};

export const buildUllagesMenuItems: () => MenuItem[] = () => [
  MenuItem.forBranch({
    translationKey: keys.ullages.value,
    icon: "Delete",
    visible: () =>
      dutySchemeType.value.isUk() &&
      hasPermissionsUsingUserStore([EnumUserPermission.menuUllagesView]),
    subMenus: [
      MenuItem.forRoute(keys.ullages_list, ullageRoutes.list),
      MenuItem.forRoute(keys.ullages_report, ullageRoutes.report),
    ],
  }),
];
